var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4713 11.5545L13.4287 13.5M12.3617 9.44845C12.3617 11.0768 11.0335 12.3969 9.3952 12.3969C7.75685 12.3969 6.42871 11.0768 6.42871 9.44845C6.42871 7.82007 7.75685 6.5 9.3952 6.5C11.0335 6.5 12.3617 7.82007 12.3617 9.44845Z",
    stroke: "#825DFC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionDatabase);
export default __webpack_public_path__ + "static/media/question-database.f62d1dbab18304f39afd500b48a57883.svg";
export { ForwardRef as ReactComponent };